import React from 'react';
import ItinerarySegmentBanner from '@kiwicom/orbit-components/lib/Itinerary/ItinerarySegment/ItinerarySegmentBanner';
import { ItineraryBadge } from '@kiwicom/openapi-sdk/mmb';

import ItineraryBadgeList from '../ItineraryBadgeList';

type FooterBadgesBannerProps = {
  footerBadges: ItineraryBadge[];
};

/**
 * Component which renders a ItinerarySegmentBanner containing a list of badges.
 * Used mostly in Schedule change alternative itineraries with footer badges of segment group.
 * @param footerBadges - list of badges to be rendered
 *
 * @returns FooterBadgesBanner component
 */
const FooterBadgesBanner = ({ footerBadges }: FooterBadgesBannerProps) => {
  return (
    <ItinerarySegmentBanner>
      <ItineraryBadgeList badges={footerBadges} spaceAfter="none" spacing="200" />
    </ItinerarySegmentBanner>
  );
};
export default FooterBadgesBanner;
